import React from "react";
import "./about.css";
function Aboutus() {
  return (
    <div className="row abtrow">
      <div className="col l8 m8 s12 xs12 abc">
        <h1 className="abthd">Welcome To Our Plateform</h1>
        <p className="about-para">
          The website is generic to some extent, Yet it is specific to law and
          law industry.
          <br />
          Legal resources for Lawyers, Advocates, Judges, Businessmen, Students
          and <br /> other legal professionals at one place Legal resources at
          Lawyers Online includes <br /> Statues (
          <b> Acts, Rules, Ordinances </b> etc.) Search facilities, sent email
          and <br /> other related information therefore, this site after its
          hosting on web <br /> attracted the attention of the surfers, web
          users by getting such advantages. <br /> The Lawyers Online
          successfully aiming its goal by spreading legal knowledge <br />
          in society and promoting the law culture in society as well.
        </p>
      </div>
      <div className="col l4 m4 s12 xs12 abcd">
        <img className="img2" src="Lawyers.png" alt="" />
      </div>
    </div>
  );
}

export default Aboutus;

{
  /* <div className="hero1">
      <div className="row">
        <div className="col m8 clg" id="section">
          <div className="margin">
            <h1>Welcome To Our Plateform</h1>
            <p className="about-para">
              The website is generic to some extent, Yet it is specific to law
              and law industry.
              <br />
              Legal resources for Lawyers, Advocates, Judges, Businessmen,
              Students and <br /> other legal professionals at one place Legal
              resources at Lawyers Online includes <br /> Statues (
              <b> Acts, Rules, Ordinances </b> etc.) Search facilities, sent
              email and <br /> other related information therefore, this site
              after its hosting on web <br /> attracted the attention of the
              surfers, web users by getting such advantages. <br /> The Lawyers
              Online successfully aiming its goal by spreading legal knowledge{" "}
              <br />
              in society and promoting the law culture in society as well.
            </p>
          </div>
        </div>
        <div className="col m4">
          <figure>
            <img className="img2" src="Lawyers.png" alt="" />
          </figure>
        </div>
      </div>
    </div> */
}
